module.exports = require('./core.json').reduce(function (acc, x) {
    acc[x] = true;
    return acc;
}, {});



//////////////////
// WEBPACK FOOTER
// ./~/istanbul/~/resolve/lib/core.js
// module id = 796
// module chunks = 0